import React from "react";
import Divider from "../../../Divider";
import { BaseGroupLabel } from "./styled";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
function GroupLabel(_ref) {
  var label = _ref.label,
    isFirstItem = _ref.isFirstItem;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [!isFirstItem && /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx(BaseGroupLabel, {
      children: label
    })]
  });
}
export default GroupLabel;